<template>
  <div class="custom-loading" :style="customStyle">
    <div class="custom-indicator">
      <div class="custom-animation">
        <!-- Local CSS spinner on purpose. The portals register Font Awesome through
             fontawesome-svg-core + dom.watch(), which rewrites an <i> into an <svg> after Vue has
             mounted it, and the fa-spin animation did not survive that on a dynamically inserted
             overlay. This owns its own keyframes, so it animates wherever the component is used. -->
        <span class="custom-spinner" aria-hidden="true"></span>
        <span class="custom-notice">{{ notice }}</span>
      </div>
      <button v-if="isShowCancel" class="btn btn-link custom-cancel" @click="cancel">cancel</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ZOverlay',
  props: {
    notice: {
      type: String,
      default: 'loading'
    },
    customStyle: String
  },
  emits: ['cancel'],
  data() {
    return {
      isShowCancel: false,
      cancelTimer: null
    }
  },
  mounted() {
    let $this = this
    this.isShowCancel = false
    this.cancelTimer = setTimeout(() => {
      $this.isShowCancel = true
    }, 15000)
  },
  beforeUnmount() {
    // Without this the timer keeps a reference to a torn-down component and flips isShowCancel on it.
    if (this.cancelTimer) {
      clearTimeout(this.cancelTimer)
      this.cancelTimer = null
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
@keyframes custom-spin {
  to {
    transform: rotate(360deg);
  }
}
.custom-loading {
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  left: 0;
}
.custom-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
  // Sizes to its label: a longer notice such as "submitting" used to wrap inside a fixed 150px box.
  min-width: 150px;
  padding: 18px 22px;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}
.custom-animation {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  white-space: nowrap;
}
.custom-spinner {
  display: inline-block;
  flex: none;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-top-color: #0d6efd;
  border-radius: 50%;
  animation: custom-spin 0.7s linear infinite;
}
@media (prefers-reduced-motion: reduce) {
  .custom-spinner {
    animation-duration: 2.4s;
  }
}
.custom-notice {
  line-height: 1;
}
.custom-cancel {
  font-size: 0.8em;
  padding: 0;
  margin-top: 8px;
  line-height: 1;
}
</style>
